import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FooterComponent, HeaderComponent, SidebarMenuComponent } from '@careconne/core/components';
import {
  CustomPaginatorDirective,
  NoWhitespaceDirective,
  InputMaxLengthByteDirective,
  LatinOnlyDirective,
  AppOnlyNumberDirective,
} from '@careconne/core/directives';
import { LayoutComponent } from '@careconne/core/layouts';
import { MaterialModule } from '@careconne/core/material';
import { SameDateDisplayPipe } from '@careconne/core/pipes';

import { MapNameFromArrPipe, MapNamePipe } from './pipes/map-name.pipe';

const COMPONENTS = [HeaderComponent, FooterComponent, SidebarMenuComponent, LayoutComponent];

const DIRECTIVES = [
  CustomPaginatorDirective,
  NoWhitespaceDirective,
  InputMaxLengthByteDirective,
  LatinOnlyDirective,
  AppOnlyNumberDirective,
];
const PIPES = [SameDateDisplayPipe, MapNamePipe, MapNameFromArrPipe];

@NgModule({
  imports: [CommonModule, RouterModule, MaterialModule, TranslateModule],
  exports: [CommonModule, MaterialModule, TranslateModule, ...DIRECTIVES, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
})
export class CoreModule {}
